module.exports = __webpack_public_path__ + "std/img/ads2.c901cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/views/My/Base/components/Ads/images/ads2.png
// module id = XWr4
// module chunks = 0